gsap.registerPlugin(ScrollTrigger);
export function swiperInit() {
	function getSlidesPerGroup(slidesSizesGrid, visibleSlidesIndexes) {
		const totalSlide = slidesSizesGrid.length;
		const visibleSlide = visibleSlidesIndexes?.length ?? 1;

		let slidesPerGroup = visibleSlide;

		if (totalSlide <= visibleSlide) {
			slidesPerGroup = null;
		}
		return slidesPerGroup;
	}
	function triggerLozadNextSlideImage(swiper) {
		const nextSlide = swiper.slides[swiper.activeIndex + 1];
		if (nextSlide) {
			const nextImage = nextSlide.querySelectorAll("img");
			const loader = window.lazyLoader;
			if (nextImage && loader && typeof loader.triggerLoad === "function") {
				nextImage.forEach((img) => {
					loader.triggerLoad(img);
				});
			} else {
				throw new Error("Lozad is not defined");
			}
		}
	}
	function autoSetSlidesPerGroup(swiper) {
		if (!swiper.pagination.el) return;
		const { visibleSlidesIndexes, slidesSizesGrid } = swiper;
		const slidesPerGroup = getSlidesPerGroup(
			slidesSizesGrid,
			visibleSlidesIndexes
		);
		if (
			slidesPerGroup != null &&
			slidesPerGroup > 0 &&
			slidesPerGroup !== swiper.params.slidesPerGroup
		) {
			swiper.params.slidesPerGroup = slidesPerGroup;
			swiper.update();
		}
	}


	var partnerSwiper = new Swiper(".partner-swiper .swiper", {
		loop: true,
		speed: 2000,
		spaceBetween: 20,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		breakpoints: {
			320: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 6,
			},
			1200: {
				slidesPerView: 8,
			},

		},
	});



	var slideNumberVerticalSwiper = new Swiper(".slide-number-vertical .swiper", {
		loop: true,
		speed: 900,
		spaceBetween: 20,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false,
		},
		direction: "vertical",
		breakpoints: {
			320: {
				slidesPerView: 1,
			},

		},
	});


	// 1. Initialize Swiper
	window.primarySwiper = new Swiper(".primary-banner .swiper", {
		slidesPerView: 1,
		observer: true,
		observeParents: true,
		preventInteractionOnTransition: false,
		speed: 1205,
		autoplay: false,
		lazy: {
			loadPrevNext: true,
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		init: false,
		navigation: {
			nextEl: ".primary-banner .next",
			prevEl: ".primary-banner .prev",
		},
		pagination: {
			el: ".primary-banner .swiper-pagination",
			type: "bullets",
			clickable: true,
			renderBullet: function (index, className) {
				return `<span class="${className}" data-index="${index}"></span>`;
			},
		},
	});

	// 2. Global Variables
	let progressInterval = null;
	let timer = null;
	let isPaused = false; // NEW: Track manual pause state
	const slideTimeout = 4000;


	// GLOBAL
	window.triggerFadeUp = function (slide) {
		if (!window.introFinished) return;

		if (!slide) return;

		const texts = slide.querySelectorAll(".text-fd-up");

		texts.forEach((el) => {
			el.classList.remove("is-visible");

			// force reflow
			void el.offsetWidth;

			el.classList.add("is-visible");
		});
	};


	// 3. Progress Track Function
	function startProgressTrack() {
		if (progressInterval) clearInterval(progressInterval);
		if (isPaused) return; // Don't start animation if paused

		const progressTrack = document.querySelector(".primary-banner .progress-track");
		if (!progressTrack) return;

		const intervalStep = 20;
		// Get current width to allow resuming from same spot if desired, 
		// otherwise it defaults to 0 on new slides.
		let progress = parseFloat(progressTrack.style.width) || 0;

		progressInterval = setInterval(() => {
			if (!isPaused) {
				progress += (intervalStep / slideTimeout) * 100;
				if (progress >= 100) {
					clearInterval(progressInterval);
					progressTrack.style.width = "100%";
				} else {
					progressTrack.style.width = `${progress}%`;
				}
			}
		}, intervalStep);
	}

	function resetProgressTrack() {
		if (progressInterval) {
			clearInterval(progressInterval);
			progressInterval = null;
		}
		const progressTrack = document.querySelector(".primary-banner .progress-track");
		if (progressTrack) {
			progressTrack.style.width = "0%";
		}
	}

	// 4. Video & Timer Handling
	function handleVideoPlayback(slide) {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}

		if (!isPaused) {
			resetProgressTrack();
		}

		// Stop all videos first
		const allVideos = document.querySelectorAll(".primary-banner-video");
		allVideos.forEach((video) => {
			video.pause();
		});

		// Detect which video to play based on screen width
		// Adjust 768 to match your specific CSS breakpoint (e.g., 1024 for desktop)
		const isMobile = window.innerWidth <= 768;
		const videoSelector = isMobile ? "video.mobile" : "video.desktop";

		let videoElement = slide.querySelector(videoSelector);

		// Fallback: If the specific mobile/desktop video doesn't exist, 
		// grab whatever video is available in the slide.
		if (!videoElement) {
			videoElement = slide.querySelector("video");
		}

		if (videoElement) {
			videoElement.muted = true;           // force muted via JS too (iOS quirk)
			videoElement.setAttribute('playsinline', '');
			videoElement.setAttribute('webkit-playsinline', '');

			if (!isPaused) {
				startProgressTrack();

				// iOS needs load() before play() when src is set dynamically
				if (videoElement.readyState === 0) {
					videoElement.load();
				}

				const playPromise = videoElement.play();
				if (playPromise !== undefined) {
					playPromise.catch((error) => {
						console.warn('Autoplay blocked:', error);
						// Fallback: treat it like an image slide
						timer = setTimeout(() => {
							primarySwiper.slideNext();
						}, slideTimeout);
					});
				}
			}




		} else {
			// Handle Image Slides
			if (!isPaused) {
				startProgressTrack();
				timer = setTimeout(() => {
					primarySwiper.slideNext();
				}, slideTimeout);
			}
		}
	}

	// 5. Swiper Event Listeners
	primarySwiper.on("slideChangeTransitionEnd", function () {
		const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
		handleVideoPlayback(currentSlide);
		triggerFadeUp(currentSlide);
	});

	primarySwiper.on("slideChangeTransitionStart", function () {
		if (!isPaused) {
			resetProgressTrack();
		}
	});

	primarySwiper.on("init", function () {
		const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
		handleVideoPlayback(currentSlide);
		triggerFadeUp(currentSlide);
	});

	// 6. Pause Button Logic (.pause-track)
	const pauseTrackBtn = document.querySelector(".pause-track");
	if (pauseTrackBtn) {
		pauseTrackBtn.addEventListener("click", function () {
			isPaused = !isPaused; // Toggle state

			const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
			const video = currentSlide.querySelector("video");

			if (isPaused) {
				// STOP
				this.classList.add("paused");
				if (progressInterval) clearInterval(progressInterval);
				if (timer) clearTimeout(timer);
				if (video) video.pause();
			} else {
				// RESUME
				this.classList.remove("paused");
				if (video) {
					video.play();
					startProgressTrack();
				} else {
					startProgressTrack();
					// Resume the remaining time (simplified as full timeout here)
					timer = setTimeout(() => {
						primarySwiper.slideNext();
					}, slideTimeout);
				}
			}
		});
	}

	// 7. Manual Video Click Handling
	const primaryBannerVideo = document.querySelectorAll(".primary-banner-video");
	primaryBannerVideo.forEach(function (videoElement) {
		videoElement.addEventListener("click", function (event) {
			if (this.paused) {
				this.play();
				this.parentNode.classList.remove("pause");
			} else {
				this.pause();
				this.parentNode.classList.add("pause");
			}
		});
	});

	// 8. Run Init
	primarySwiper.init();





	window.initSwiper = [];

	$(".init-swiper .swiper").each(function (index) {
		const $this = $(this);

		const isLoop = $this.hasClass("is-loop");
		const isTriggerLoadedNext = $this.hasClass("trigger-loaded-next");
		const isCenter = $this.hasClass("is-center-slide");

		let time = parseInt($this.attr("data-time"), 10);
		if (isNaN(time)) time = 5000;

		// Pagination type
		let paginationType = "bullets";
		if ($this.hasClass("fraction")) {
			paginationType = "fraction";
		} else if ($this.hasClass("progress")) {
			paginationType = "progressbar";
		}

		// Unique classes
		$this.addClass("swiper-init-" + index);
		$this.parents(".init-swiper").find(".prev").addClass("prev-nav-" + index);
		$this.parents(".init-swiper").find(".next").addClass("next-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-inst-" + index);

		// Base options
		const options = {
			observer: true,
			observeParents: true,
			rewind: !isLoop,
			speed: 1205,
			watchSlidesProgress: true,
			slidesPerView: "auto",

			lazy: {
				loadPrevNext: true,
			},

			loop: isLoop,

			autoplay: {
				delay: time,
				pauseOnMouseEnter: true,
			},

			navigation: {
				nextEl: ".next-nav-" + index,
				prevEl: ".prev-nav-" + index,
			},

			pagination: {
				el: ".pagination-inst-" + index,
				type: paginationType,
				clickable: true,
				dynamicMainBullets: 1,
			},

			// ✅ Center mode
			centeredSlides: isCenter,

			on: {
				beforeInit: function () {
					window.initSwiper.push(this);
				},

				init: function () {
					// Fix duplicate fancybox in loop mode
					if (isLoop) {
						window.lozadInit?.();

						$(this.el)
							.find(".swiper-slide-duplicate a[data-fancybox]")
							.removeAttr("data-fancybox");
					}

					if (isTriggerLoadedNext) {
						triggerLozadNextSlideImage(this);
					}
				},

				slideChange: function () {
					// Pause videos when slide changes
					if ($this.hasClass("slide-has-video")) {
						const $videos = $this.find("video");
						if ($videos.length) {
							$videos[0].pause();
						}

						$this.find(".swiper-slide").removeClass("play-video");
						$this.find(".play-btn").removeClass("active");
					}

					if (isTriggerLoadedNext) {
						triggerLozadNextSlideImage(this);
					}
				},

				resize: function (swiper) {
					const totalSlidesWidth = swiper.slidesSizesGrid.reduce(
						(acc, curr) => acc + curr,
						0
					);

					swiper.el.classList.toggle(
						"center-slide-active",
						totalSlidesWidth < swiper.size
					);

					autoSetSlidesPerGroup(swiper);
				},
			},
		};

		// ✅ Improve center behavior
		if (isCenter) {
			options.centeredSlidesBounds = true;
		}

		// ✅ Initial slide support
		const initialSlide = parseInt($this.attr("data-initial"), 10);
		if (!isNaN(initialSlide)) {
			options.initialSlide = initialSlide;
		}

		// ✅ Special case: continuous autoplay
		if (time === 0) {
			options.autoplay = {
				delay: 0,
				disableOnInteraction: true,
				pauseOnMouseEnter: false,
			};

			options.loop = true;
			options.speed = 1800;

			delete options.navigation;
		}

		// Init Swiper
		new Swiper(".swiper-init-" + index, options);
	});



	var gridSwiper = new Swiper(".branding-grid-swiper .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 15,
		observeParents: true,
		simulateTouch: false,
		breakpoints: {
			320: {
				slidesPerView: 2,

			},
			490: {
				slidesPerView: 3,
				grid: {
					rows: 2,
					fill: "row",
				},
			},

			768: {
				slidesPerView: 4,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 15,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1400: {
				slidesPerView: 3,
				spaceBetween: 20,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
		},
		navigation: {
			nextEl: ".partner-grid-swiper .next",
			prevEl: ".partner-grid-swiper .prev",
		},
	});
	var aboutGridSwiper = new Swiper(".about-grid-swiper .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		loop: true,
		speed: 2000,
		spaceBetween: 20,
		watchSlidesProgress: true,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 15,
		simulateTouch: false,
		breakpoints: {
			320: {
				slidesPerView: 2,

			},
			420: {
				slidesPerView: 3,

			},

			768: {
				slidesPerView: 4,

			},
			1024: {
				slidesPerView: 6,
				spaceBetween: 40,

			},
			1400: {
				slidesPerView: 8,
				spaceBetween: 40,

			},
		},

	});
	var aboutGridSwiper = new Swiper(".about-grid-swiper-2 .swiper", {
		preventInteractionOnTransition: true,
		observer: true,
		observeParents: true,
		loop: true,
		speed: 2000,
		spaceBetween: 20,
		watchSlidesProgress: true,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		spaceBetween: 15,
		simulateTouch: false,
		breakpoints: {
			320: {
				slidesPerView: 2,

			},
			420: {
				slidesPerView: 3,

			},

			768: {
				slidesPerView: 4,

			},
			1024: {
				slidesPerView: 6,
				spaceBetween: 40,

			},
			1400: {
				slidesPerView: 8,
				spaceBetween: 40,

			},
		},

	});


	var certProductSwiper = new Swiper(".cert-product-swiper .swiper", {
		spaceBetween: 0,
		slidesPerView: "auto",
		watchSlidesProgress: true,
		slideToClickedSlide: true,
		loop: true,
		speed: 2000,
		spaceBetween: 0,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		breakpoints: {
			200: {
				slidesPerView: "auto",
			},

		},
	});

	window.certProductSwiper = certProductSwiper;




	try {
		if (window.innerWidth > 1200) {
			var homeDevelopeSwiper = new Swiper(".home-develope .swiper", {
				spaceBetween: 10,
				watchSlidesProgress: true,
				slideToClickedSlide: true,
				speed: 700,
				simulateTouch: false,
				allowTouchMove: false,
				freeMode: {
					enabled: true,
					momentum: true,
					momentumRatio: .1,
				},

				mousewheel: false,
				autoplay: false,

				slidesPerView: "auto",
				lazy: {
					loadPrevNext: true,
				},
				breakpoints: {
					200: { spaceBetween: 10 },
					476: { spaceBetween: 20 },
					768: { spaceBetween: 30 },
					1024: { spaceBetween: 40 },
					1280: { spaceBetween: 80 },
				},
			});
		}
		else {
			// ---------- THUMB SLIDER ----------
			var homeThumb = new Swiper(".home-develope .swiper", {
				spaceBetween: 20,
				watchSlidesProgress: true,
				slideToClickedSlide: true,
				speed: 1205,
				autoplay: false,
				lazy: {
					loadPrevNext: true,
				},
				slidesPerView: 1.5
				// breakpoints: {
				// 	200: {
				// 		slidesPerView: 1.5,
				// 	},
				// 	476: {
				// 		slidesPerView: 1.5,
				// 	},
				// 	768: {
				// 		slidesPerView: 2,
				// 	},
				// 	1024: {
				// 		slidesPerView: 3,
				// 	},
				// 	1280: {
				// 		slidesPerView: 4,
				// 	},
				// },
			});
		}
	} catch (error) { }
	window.homeDevelopeSwiper = homeDevelopeSwiper;


	try {

		if ($('body').hasClass('homepage')) {
			if (window.innerWidth > 1200) {
				window.homeDevelopeSwiper = homeDevelopeSwiper;

				const swiper = homeDevelopeSwiper;
				const header = document.querySelector('header');
				const getHeaderHeight = () => header ? header.offsetHeight - 30 : 0;

				// ── DESKTOP ≥ 1200px — original fullpage.js wheel logic ───────────
				let lastSectionTime = 0;
				const sectionDelay = 600;
				let scrollProxy = { translate: swiper.translate };

				$('.home-develope').closest('.section').on('wheel', function (e) {
					const now = Date.now();
					const stats = window._fpScrollDebug && window._fpScrollDebug.wheels;
					const fpLog = window.fpScrollDebug || function () {};

					// Only handle wheels while this section is the active snap.
					// Incoming leftover ticks during branding → develope must
					// not call moveSectionDown() and skip into the last block.
					if (!$(this).hasClass("active")) {
						if (stats) {
							stats.inactive += 1;
							if (stats.inactive === 1) {
								fpLog("leftover wheel on INACTIVE develope", {
									theory: "ticks during branding → develope snap",
									deltaY: e.originalEvent.deltaY,
								});
							}
						}
						return;
					}

					if (now < (window._developeWheelLockUntil || 0)) {
						if (stats) {
							stats.locked += 1;
							if (stats.locked === 1) {
								fpLog("leftover wheel swallowed by lock", {
									theory: "inertia after landing on develope",
									lockLeftMs: window._developeWheelLockUntil - now,
									deltaY: e.originalEvent.deltaY,
								});
							}
						}
						e.preventDefault();
						return;
					}

					const delta = e.originalEvent.deltaY;
					const isFirstSlide = swiper.isBeginning;
					const isLastSlide = swiper.isEnd;

					if (!gsap.isTweening(scrollProxy)) {
						scrollProxy.translate = swiper.translate;
					}

					if (delta > 0 && isLastSlide) {
						if (now - lastSectionTime < sectionDelay) {
							if (stats) stats.delay += 1;
							e.preventDefault();
							return;
						}
						lastSectionTime = now;
						if (stats) stats.leaveDown += 1;
						fpLog("swiper moveSectionDown", {
							theory: "timeline at end, forcing leave to last block",
							isLastSlide,
							isFirstSlide,
						});
						fullpage_api.setAllowScrolling(true);
						fullpage_api.moveSectionDown();
						return;
					}

					if (delta < 0 && isFirstSlide) {
						if (now - lastSectionTime < sectionDelay) {
							if (stats) stats.delay += 1;
							e.preventDefault();
							return;
						}
						lastSectionTime = now;
						if (stats) stats.leaveUp += 1;
						fpLog("swiper moveSectionUp", {
							theory: "timeline at start, forcing leave to branding",
							isLastSlide,
							isFirstSlide,
						});
						fullpage_api.setAllowScrolling(true);
						e.preventDefault();
						fullpage_api.moveSectionUp();
						return;
					}

					if (stats) stats.scrub += 1;

					e.preventDefault();
					fullpage_api.setAllowScrolling(false);

					let newTarget = scrollProxy.translate - (delta * 3.5);
					newTarget = Math.max(
						swiper.maxTranslate(),
						Math.min(swiper.minTranslate(), newTarget)
					);

					gsap.to(scrollProxy, {
						translate: newTarget,
						duration: 0.6,
						ease: 'power2.out',
						overwrite: 'auto',
						onUpdate: () => {
							swiper.setTranslate(scrollProxy.translate);
							swiper.updateProgress();
							swiper.updateActiveIndex();
						}
					});
				});


			}
		}
	} catch (error) { }
	try {
		if ($('body').hasClass('page-template-template_about')) {

			ScrollTrigger.matchMedia({
				'(min-width: 1200px)': function () {

					window.homeDevelopeSwiper = homeDevelopeSwiper;

					const swiper = homeDevelopeSwiper;
					const header = document.querySelector('header');
					const getHeaderHeight = () => header ? header.offsetHeight - 30 : 0;

					const COOLDOWN = 100;
					const WHEEL_MULT = 3.5;
					const EPS = 10;
					const DELTA_THRESHOLD = 1.5;
					const RELEASE_OFFSET = 24;
					const REENGAGE_DELAY = 450;

					const scrollProxy = { translate: swiper.translate };
					let engaged = false;
					let lockedEdge = null;
					let lockTime = 0;
					let releaseUntil = 0;

					const seed = (translate) => {
						scrollProxy.translate = translate;
						swiper.setTranslate(translate);
						swiper.updateProgress();
						swiper.updateActiveIndex();
						lockedEdge = null;
					};

					const releasePin = (targetY) => {
						engaged = false;
						lockedEdge = null;
						releaseUntil = Date.now() + REENGAGE_DELAY;

						gsap.killTweensOf(scrollProxy);
						gsap.killTweensOf(window);

						gsap.to(window, {
							scrollTo: targetY,
							duration: 0.55,
							ease: 'power2.out',
							overwrite: 'auto',
							autoKill: false,
						});
					};

					const st = ScrollTrigger.create({
						trigger: ".home-develope",
						start: () => `top ${getHeaderHeight()}px`,
						end: () => `+=${Math.abs(swiper.maxTranslate()) * 2.5}`,
						pin: true,
						pinSpacing: true,
						invalidateOnRefresh: true,
						onEnter: () => {
							if (Date.now() < releaseUntil) return;
							engaged = true;
							seed(swiper.minTranslate());
						},
						onEnterBack: () => {
							if (Date.now() < releaseUntil) return;
							engaged = true;
							seed(swiper.maxTranslate());
						},
						onLeave: () => {
							engaged = false;
							lockedEdge = null;
						},
						onLeaveBack: () => {
							engaged = false;
							lockedEdge = null;
						},
					});

					const onWheel = (e) => {
						if (!engaged) return;

						e.preventDefault();

						const now = Date.now();
						const delta = e.deltaY;

						if (Math.abs(delta) < DELTA_THRESHOLD) return;

						if (!gsap.isTweening(scrollProxy)) {
							scrollProxy.translate = swiper.translate;
						}

						const minT = swiper.minTranslate();
						const maxT = swiper.maxTranslate();
						const atEnd = scrollProxy.translate <= maxT + EPS;
						const atStart = scrollProxy.translate >= minT - EPS;

						if (delta > 0 && atEnd) {
							if (lockedEdge !== 'end') {
								lockedEdge = 'end';
								lockTime = now;
								return;
							}

							if (now - lockTime < COOLDOWN) return;

							releasePin(st.end + RELEASE_OFFSET);
							return;
						}

						if (delta < 0 && atStart) {
							if (lockedEdge !== 'start') {
								lockedEdge = 'start';
								lockTime = now;
								return;
							}

							if (now - lockTime < COOLDOWN) return;

							releasePin(st.start - RELEASE_OFFSET);
							return;
						}

						if (lockedEdge === 'end' && delta < 0) lockedEdge = null;
						else if (lockedEdge === 'start' && delta > 0) lockedEdge = null;

						let newTarget = scrollProxy.translate - (delta * WHEEL_MULT);
						newTarget = Math.max(maxT, Math.min(minT, newTarget));

						gsap.to(scrollProxy, {
							translate: newTarget,
							duration: 0.6,
							ease: "power2.out",
							overwrite: "auto",
							onUpdate: () => {
								swiper.setTranslate(scrollProxy.translate);
								swiper.updateProgress();
								swiper.updateActiveIndex();
							}
						});
					};

					window.addEventListener('wheel', onWheel, { passive: false });

					return () => {
						window.removeEventListener('wheel', onWheel);
						st.kill();
					};
				}
			});
		}
	} catch (error) { }



	const groupViewMore = $('.view-more-group');
	const btnToggleViewMore = $('.btn-view-more-toggle');

	if (btnToggleViewMore !== null) {
		btnToggleViewMore.on('click', function () {
			groupViewMore.stop(true, true).slideToggle(800, function () {
				// Runs after slideToggle animation completes
				ScrollTrigger.refresh();
			});
			$(this).toggleClass('is-close');
		});
	}



	// ---------- THUMB SLIDER ----------
	var homeThumb = new Swiper(".home-thumb .swiper", {
		spaceBetween: 0,
		watchSlidesProgress: true,
		slideToClickedSlide: true,
		speed: 1205,
		autoplay: false,
		lazy: {
			loadPrevNext: true,
		},
		breakpoints: {
			200: {
				slidesPerView: 1,
			},
			476: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
			},
		},
	});

	window.homeThumb = homeThumb;


	// ---------- MAIN SLIDER ----------
	var homeMain = new Swiper(".home-main .swiper", {
		spaceBetween: 10,
		centeredSlides: true,
		speed: 1205,
		rewind: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		thumbs: {
			swiper: homeThumb,
		},
	});

	window.homeMain = homeMain;



	var productThumb = new Swiper(".product-thumb .swiper", {
		spaceBetween: 20,
		breakpoints: {
			200: {
				slidesPerView: 4,
				spaceBetween: 10,
				direction: "horizontal",
			},
			476: {
				slidesPerView: 4,
				direction: "horizontal",
			},
			768: {
				slidesPerView: 6,
				direction: "horizontal",
			},
			1024: {
				slidesPerView: 3,
				direction: "horizontal",
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 8,
				direction: "vertical",
			},
		},
		speed: 500,
		watchSlidesProgress: true,
		lazy: {
			loadPrevNext: true,
		},
	});
	window.productThumb = productThumb;
	var productMain = new Swiper(".product-main .swiper", {
		spaceBetween: 10,
		centeredSlides: true,
		speed: 1205,
		rewind: true,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".product-detail  .next-nav",
			prevEl: ".product-detail  .prev-nav",
		},
		thumbs: {
			swiper: productThumb,
		},
	});
	window.productMain = productMain;


	// ---------- HOVER THUMB → CHANGE MAIN ----------
	function bindThumbHover() {
		document
			.querySelectorAll(".home-thumb .swiper-slide")
			.forEach((slide, index) => {

				slide.addEventListener("mouseenter", () => {
					homeMain.autoplay.stop();
					homeMain.slideTo(index);
				});

				slide.addEventListener("mouseleave", () => {
					homeMain.autoplay.start();
				});
			});
	}

	// bind after Swiper is ready
	homeThumb.on("init", bindThumbHover);
	bindThumbHover();


	// ---------- KEEP THUMB IN SYNC WHEN MAIN CHANGES ----------
	homeMain.on("slideChange", () => {
		homeThumb.slideTo(homeMain.activeIndex);
	});



}


